
/// <amd-module name="Search/Shared/Base/PivotStateService" />
import { Services, VssService, IVssService } from "VSS/Platform/Context";

export interface ICountState {
    searchtext: string;

    count: number;
}

export interface IPivotTabState {
    filtersString: string | undefined;

    sortOptions: string;

    countState: ICountState;
}

export interface IPivotTabProviderState {
    pivotTabs: {
        [id: string]: IPivotTabState
    }

    availableTabs: string[];
}

export interface ISearchPivotStateService extends IVssService {
    updateState: (tabId: string, filtersString?: string, sortOptions?: string, countstate?: ICountState) => void;

    getState: (tabId: string) => IPivotTabState;


    resetFilters: (tabId: string) => void;

    resetCountState: (searchText: string) => void;
}

export class PivotStateService extends VssService implements ISearchPivotStateService {
    protected _state: IPivotTabProviderState = { pivotTabs: {}, availableTabs: [] } as IPivotTabProviderState;

    public updateState = (
        tabId: string,
        filtersString?: string,
        sortOptions?: string,
        countstate?: ICountState): void => {

        if (!this._state.pivotTabs[tabId]) {
            this._state.pivotTabs[tabId] = {} as IPivotTabState;
            this._state.availableTabs.push(tabId);
        }

        if (filtersString) {
            this._state.pivotTabs[tabId].filtersString = filtersString;
        }

        if (sortOptions) {
            this._state.pivotTabs[tabId].sortOptions = sortOptions;
        }

        if (countstate) {
            this._state.pivotTabs[tabId].countState = countstate;
        }
    }

    public getState = (tabId: string): IPivotTabState => {
        return this._state.pivotTabs[tabId];
    }

    public resetCountState = (text: string): void => {
        let tabId;
        for (let id in this._state.availableTabs) {
            tabId = this._state.availableTabs[id];
            if (this._state.pivotTabs[tabId].countState && this._state.pivotTabs[tabId].countState.searchtext !== text) {
                this._state.pivotTabs[tabId].countState = {} as ICountState;
            }
        }
    }

    public resetFilters = (providerContributionId: string): void => {
        this._state.pivotTabs[providerContributionId].filtersString = undefined;
    }
}

Services.add("ISearchPivotStateService", { serviceFactory: PivotStateService });